<template>
  <v-col
    class="d-flex flex-column justify-center align-center
                                      table-right-border table-right-border-light
                                      text-center result-columns-align-width"
  >
    <template v-if="covered === 'Y'">
      <v-icon
        large
        color="primary"
        class="mb-1"
      >
        mdi-check
      </v-icon>
      <p class="caption font-weight-medium mb-0">
        Included
      </p>
      <p class="fs-10 mb-0">
        as standard
      </p>
    </template>

    <template v-if="covered === 'extra'">
      <v-icon
        large
        color="primary"
        class="mb-1"
      >
        mdi-plus
      </v-icon>
      <p class="caption font-weight-medium mb-0">
        Available
      </p>
    </template>

    <template v-if="covered === 'N'">
      <v-icon
        large
        color="navy-dark"
        class="mb-1"
      >
        mdi-close
      </v-icon>
      <p class="caption font-weight-medium mb-0">
        Not Available
      </p>
    </template>
  </v-col>
</template>

<script>
export default {
  name: 'quote-options',
  props: {
    covered: {
      type: String,
      default: 'Y',
    },
  },
};
</script>
